import React from "react";
import RegisterPage from "../components/RegisterPage";
import { useHSE } from "../lib/store";

const SEV = {
  Low: { bg: "#DCFCE7", color: "#166534" },
  Medium: { bg: "#FEF3C7", color: "#854D0E" },
  High: { bg: "#FFE4E6", color: "#9F1239" },
  Critical: { bg: "#FEE2E2", color: "#7F1D1D" },
};
const STATUS = {
  Open: { bg: "#FEF3C7", color: "#854D0E" },
  "In Progress": { bg: "#DBEAFE", color: "#1E40AF" },
  Closed: { bg: "#DCFCE7", color: "#166534" },
  Overdue: { bg: "#FEE2E2", color: "#7F1D1D" },
};
const CLASSIF = {
  FAC: { bg: "#FEF3C7", color: "#854D0E" },
  MTC: { bg: "#FFE4E6", color: "#9F1239" },
  LTI: { bg: "#FEE2E2", color: "#7F1D1D" },
  "Near Miss": { bg: "#DBEAFE", color: "#1E40AF" },
  "Property Damage": { bg: "#F1F5F9", color: "#334155" },
};

export default function Incidents() {
  const { data, siteNames } = useHSE();
  const incidentTypes = data.settings?.incidentTypes?.length
    ? data.settings.incidentTypes
    : ["Slip/Trip/Fall", "Struck By Object", "Equipment Failure", "Chemical Spill", "Electrical", "Vehicle", "Manual Handling", "Fire/Smoke"];
  return (
    <RegisterPage
      title="Lagging Indicators"
      subtitle="Incident statistics for near miss, first aid, fatality, LTI, RWDC, MTC and environmental cases"
      storeKey="incidents"
      idPrefix="INC"
      columns={[
        { key: "id", label: "Incident ID" },
        { key: "date", label: "Date" },
        { key: "site", label: "Site" },
        { key: "department", label: "Dept" },
        { key: "location", label: "Location" },
        { key: "type", label: "Type" },
        { key: "classification", label: "Class" },
        { key: "severity", label: "Severity" },
        { key: "responsible", label: "Responsible" },
        { key: "dueDate", label: "Due" },
        { key: "status", label: "Status" },
      ]}
      badgeMap={{ severity: SEV, classification: CLASSIF, status: STATUS }}
      formFields={[
        { key: "id", label: "Incident ID" },
        { key: "date", label: "Date", type: "date" },
        { key: "site", label: "Site", type: "select", options: siteNames },
        { key: "department", label: "Department", type: "select", options: data.settings.departments },
        { key: "location", label: "Location" },
        { key: "type", label: "Incident Type", type: "select", options: incidentTypes },
        { key: "classification", label: "Classification", type: "select", options: ["FAC", "MTC", "LTI", "Near Miss", "Property Damage"] },
        { key: "severity", label: "Severity", type: "select", options: ["Low", "Medium", "High", "Critical"] },
        { key: "description", label: "Description", type: "textarea", full: true },
        { key: "rootCause", label: "Root Cause" },
        { key: "immediateAction", label: "Immediate Action" },
        { key: "correctiveAction", label: "Corrective Action", full: true },
        { key: "responsible", label: "Responsible Person" },
        { key: "dueDate", label: "Due Date", type: "date" },
        { key: "status", label: "Status", type: "select", options: ["Open", "In Progress", "Closed"] },
      ]}
    />
  );
}
